module.exports = __webpack_public_path__ + "icon_grade-1f9e039d0f024626ab071d18098b65a0.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mailer/icon_grade.png
// module id = 275
// module chunks = 88